function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $helpers, Array, JSON, Object, iconSide) {
    var h = require("panel").h;
    var jade_mixins = {},
      $mixins = jade_mixins;
    jade_mixins['icon-container'] = function(attrs) {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        const {
          icon
        } = attrs;;
        __jade_nodes = __jade_nodes.concat(h("div", {
          "attrs": __vjadeStringifyAttrsIfObj({
            icon
          }),
          "class": Object.assign({}, {
            [`icon-side-${iconSide}`]: true
          }, {
            'icon-container': true
          }),
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("svg-icon", {
            "attrs": __vjadeStringifyAttrsIfObj({
              icon
            }),
          }));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this);
    };

    var __vjadeStringifyAttrsIfObj = function(attrs) {
      if (typeof attrs !== 'object') return attrs;
      const copy = {};
      for (const [k, v] of Object.entries(attrs)) {
        copy[k] = typeof attrs[k] === 'object' ? JSON.stringify(v) : v;
      }
      return copy;
    }
    return {
      value: (h("div", {
        "class": Object.assign({}, {
          'toggle-large': $attr(`size`) === `large`,
          'theme-tabbar': $attr(`theme`) === `tab-bar`,
          'theme-segcon': $attr(`theme`) === `segmented-controller`,
        }, {
          'mp-toggle': true
        }),
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat((function() {
          var $$obj = ($helpers.toggleOptions());
          var $$eachNodes;
          var $$iterated = false;
          if (Array.isArray($$obj)) {
            $$eachNodes = $$obj.reduce(function($$eachNodes, toggleOption, idx) {
              $$iterated = true;
              return $$eachNodes.concat((function() {
                var __jade_nodes = [];
                const {
                  icon,
                  label,
                  value,
                  disabled,
                  tooltipLabel
                } = toggleOption;;
                const hasTextAndIcon = icon && label.length;;
                __jade_nodes = __jade_nodes.concat(($attr(`theme`) === `segmented-controller`) ? ((function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("div", {
                    "class": {
                      'mp-toggle-option': true
                    },
                  }, (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("mp-button", {
                      "attrs": __vjadeStringifyAttrsIfObj({
                        theme: `tertiary`,
                        size: $attr(`size`),
                        icon,
                        disabled,
                        pressed: value === $attr(`selected`),
                        'not-focusable': true,
                      }),
                      "on": {
                        click: () => !disabled && $helpers.selectOption(value),
                      },
                    }, (function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat(label);;
                      return __jade_nodes
                    }).call(this).filter(Boolean)));
                    __jade_nodes = __jade_nodes.concat((tooltipLabel) ? ((function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
                        "attrs": __vjadeStringifyAttrsIfObj({
                          placement: `top`
                        }),
                      }, (function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(h("div", {
                          "class": {
                            'tooltip-content': true
                          },
                        }, (function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(tooltipLabel);;
                          return __jade_nodes
                        }).call(this).filter(Boolean)));;
                        return __jade_nodes
                      }).call(this).filter(Boolean)));;
                      return __jade_nodes
                    }).call(this)) : undefined);;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));;
                  return __jade_nodes
                }).call(this)) : ((function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("div", {
                    "on": {
                      click: () => !disabled && $helpers.selectOption(value),
                    },
                    "class": Object.assign({}, {
                      'mp-toggle-selected': value === $attr(`selected`),
                      'mp-toggle-disabled': disabled,
                      'mp-toggle-text-and-icon': hasTextAndIcon,
                    }, {
                      'mp-toggle-option': true
                    }),
                  }, (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat((icon) ? ((function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat(jade_mixins['icon-container'].call(this, {
                        icon
                      }));;
                      return __jade_nodes
                    }).call(this)) : undefined);
                    __jade_nodes = __jade_nodes.concat(label);
                    __jade_nodes = __jade_nodes.concat((tooltipLabel) ? ((function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
                        "attrs": __vjadeStringifyAttrsIfObj({
                          placement: `top`
                        }),
                      }, (function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(h("div", {
                          "class": {
                            'tooltip-content': true
                          },
                        }, (function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(tooltipLabel);;
                          return __jade_nodes
                        }).call(this).filter(Boolean)));;
                        return __jade_nodes
                      }).call(this).filter(Boolean)));;
                      return __jade_nodes
                    }).call(this)) : undefined);;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));;
                  return __jade_nodes
                }).call(this)));;
                return __jade_nodes
              }).call(this));
            }, []);
          } else {
            $$eachNodes = [];
            for (var $$objKey in $$obj) {
              (function() {
                var idx = $$objKey;
                if ($$obj.hasOwnProperty(idx)) {
                  $$iterated = true;
                  var toggleOption = $$obj[idx];
                  $$eachNodes = $$eachNodes.concat((function() {
                    var __jade_nodes = [];
                    const {
                      icon,
                      label,
                      value,
                      disabled,
                      tooltipLabel
                    } = toggleOption;;
                    const hasTextAndIcon = icon && label.length;;
                    __jade_nodes = __jade_nodes.concat(($attr(`theme`) === `segmented-controller`) ? ((function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat(h("div", {
                        "class": {
                          'mp-toggle-option': true
                        },
                      }, (function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(h("mp-button", {
                          "attrs": __vjadeStringifyAttrsIfObj({
                            theme: `tertiary`,
                            size: $attr(`size`),
                            icon,
                            disabled,
                            pressed: value === $attr(`selected`),
                            'not-focusable': true,
                          }),
                          "on": {
                            click: () => !disabled && $helpers.selectOption(value),
                          },
                        }, (function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(label);;
                          return __jade_nodes
                        }).call(this).filter(Boolean)));
                        __jade_nodes = __jade_nodes.concat((tooltipLabel) ? ((function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
                            "attrs": __vjadeStringifyAttrsIfObj({
                              placement: `top`
                            }),
                          }, (function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat(h("div", {
                              "class": {
                                'tooltip-content': true
                              },
                            }, (function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat(tooltipLabel);;
                              return __jade_nodes
                            }).call(this).filter(Boolean)));;
                            return __jade_nodes
                          }).call(this).filter(Boolean)));;
                          return __jade_nodes
                        }).call(this)) : undefined);;
                        return __jade_nodes
                      }).call(this).filter(Boolean)));;
                      return __jade_nodes
                    }).call(this)) : ((function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat(h("div", {
                        "on": {
                          click: () => !disabled && $helpers.selectOption(value),
                        },
                        "class": Object.assign({}, {
                          'mp-toggle-selected': value === $attr(`selected`),
                          'mp-toggle-disabled': disabled,
                          'mp-toggle-text-and-icon': hasTextAndIcon,
                        }, {
                          'mp-toggle-option': true
                        }),
                      }, (function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat((icon) ? ((function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(jade_mixins['icon-container'].call(this, {
                            icon
                          }));;
                          return __jade_nodes
                        }).call(this)) : undefined);
                        __jade_nodes = __jade_nodes.concat(label);
                        __jade_nodes = __jade_nodes.concat((tooltipLabel) ? ((function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
                            "attrs": __vjadeStringifyAttrsIfObj({
                              placement: `top`
                            }),
                          }, (function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat(h("div", {
                              "class": {
                                'tooltip-content': true
                              },
                            }, (function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat(tooltipLabel);;
                              return __jade_nodes
                            }).call(this).filter(Boolean)));;
                            return __jade_nodes
                          }).call(this).filter(Boolean)));;
                          return __jade_nodes
                        }).call(this)) : undefined);;
                        return __jade_nodes
                      }).call(this).filter(Boolean)));;
                      return __jade_nodes
                    }).call(this)));;
                    return __jade_nodes
                  }).call(this));
                }
              })();
            }
          }

          return $$eachNodes;
        })());;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };
  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "Array" in locals ? locals.Array : typeof Array !== "undefined" ? Array : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "iconSide" in locals ? locals.iconSide : typeof iconSide !== "undefined" ? iconSide : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;